import { render, staticRenderFns } from "./DanmuList.vue?vue&type=template&id=2b2d697e&"
import script from "./DanmuList.vue?vue&type=script&lang=js&"
export * from "./DanmuList.vue?vue&type=script&lang=js&"
import style0 from "./DanmuList.vue?vue&type=style&index=0&id=2b2d697e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports